export class EmptyDashValueConverter {
  public toView(value) {
    if (!value || value === '') {
      return '-';
    } else {
      return value;
    }
  }
}
